import React, { useEffect, useState } from 'react';
import styles from './CollectionsSummary.module.css';
import { BACKEND_URL } from '../config';

export default function CollectionsSummary({ range }) {
  const [summary, setSummary] = useState({});
  useEffect(() => { fetch(`${BACKEND_URL}/api/report/collections?range=${range}`).then(r => r.json()).then(setSummary).catch(console.error); }, [range]);
  const cards = [{ title: 'Total Collected', value: summary.total_collected_amount }, { title: 'Pending Collections', value: summary.pending_collections }, { title: 'Reconciled Amount', value: summary.reconciled_amount }];
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.collectionsSummaryGrid}>
        {cards.map(c => (
          <div key={c.title} className={styles.card}>
            <div className={styles.cardTitle}>{c.title}</div>
            <div className={styles.cardValue}>
              AED {Number(c.value || 0).toLocaleString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
